/**
 * A/B flag for the WhatsApp support entry points (floating button and the
 * WhatsApp row inside AI Instant Support).
 *
 *   control → WhatsApp hidden, people use in-portal support
 *   test    → WhatsApp shown
 *
 * WhatsApp renders only on an explicit `test`, so while the flag is loading —
 * or if PostHog is unavailable — nothing flashes in and out.
 */
export const WHATSAPP_SUPPORT_FLAG = 'whatsapp_support_visibility';

/** True only when the experiment explicitly puts the viewer in the shown arm. */
export const isWhatsAppSupportVisible = (variant: unknown): boolean =>
  variant === 'test';
